import { Entity, FieldType, OptionsField, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';
import { Institution } from './Institution';

export interface InstitutionProposalRow {
  institution_proposal_id: number;
  user_id: string;
  institution_name: string;
  institution_type: string;
  existing_institution: number;
  to_be_admin: boolean;
  created_at: string;
}

export const InstitutionProposal: Entity<InstitutionProposalRow> = {
  id: 'InstitutionProposal',
  title: 'Institution Proposal',
  service: 'main',
  rowLabel: (row: InstitutionProposalRow) => row.institution_name,
  primaryKeyFields: ['institution_proposal_id'],
  source: {
    tableName: 'public.institution_proposal',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  defaultSort: [['created_at', 'DESC']],
  defaultFilters: [{ fieldId: 'institution_name', operator: 'ct', value: '' }],
  listRowLink: '/admin/institution-proposal/display/{key}',
  fields: {
    institution_proposal_id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    user_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'User',
      persistence: PersistenceType.BackEndManaged,
      refEntity: UserView,
      mandatory: true,
      listColumn: true,
    },
    institution_name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Institution Name',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    institution_type: {
      seq: 20,
      label: 'Institution Type',
      type: FieldType.Options,
      persistence: PersistenceType.FrontEndGenerated,
      options: (Institution.fields.type as OptionsField).options,
    },
    existing_institution: {
      seq: 25,
      type: FieldType.Reference,
      label: 'Use Existing Institution',
      persistence: PersistenceType.FrontEndGenerated,
      refEntity: Institution,
    },
    to_be_admin: {
      seq: 30,
      type: FieldType.Boolean,
      label: 'To be Admin?',
      listColumn: true,
    },
    created_at: {
      seq: 35,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
